import { ButtonProps } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import { MenuTriggerButton } from '../../../menu-select';

export type TableMenuButtonProps = ButtonProps & {
  onRemoveClick?(): void;
  removeLabel?: string;
};

export function TableMenuButton({
  children,
  onRemoveClick,
  removeLabel,
  ...props
}: TableMenuButtonProps) {
  const { t } = useTranslation('ui');

  return (
    <MenuTriggerButton
      onClearClick={onRemoveClick}
      clearLabel={removeLabel ?? t('table.filter.remove')}
      // Table chrome is the compact tier: the whole strip (triggers, chips,
      // Save, Clear, header actions) sits at sm with the system weight, the
      // table-toolbar density Radix, Primer and Atlassian ship.
      size="sm"
      fontWeight="medium"
      {...props}
    >
      {children}
    </MenuTriggerButton>
  );
}
